import {
  OfferPreview,
  PreviewAcceptedInquiry,
} from '@texas/api/endpoints/offerApi';

export type PreviewBranch = OfferPreview['branches'][number];

export type InquiriesByBranch = Map<number, PreviewAcceptedInquiry[]>;

export function groupInquiriesByBranch(
  inquiries: PreviewAcceptedInquiry[],
): InquiriesByBranch {
  const grouped: InquiriesByBranch = new Map();
  inquiries.forEach((inquiry) =>
    grouped.set(inquiry.branchId, [
      ...(grouped.get(inquiry.branchId) ?? []),
      inquiry,
    ]),
  );
  return grouped;
}

export function getDefaultSelectedIds(preview: OfferPreview) {
  return preview.acceptedInquiries.map((inquiry) => inquiry.id);
}
